module.exports = __webpack_public_path__ + "static/media/youtube-icon.0704bd6d.svg";